import { render, staticRenderFns } from "./MemberManagementPersonnelRecords.vue?vue&type=template&id=3944dfb0"
import script from "./MemberManagementPersonnelRecords.vue?vue&type=script&lang=js"
export * from "./MemberManagementPersonnelRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports